import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endpoints } from "../../../helper/endpoints";
import { GetProductsResponse } from "../../../shared/types/quotes";
import { axiosBaseQuery } from "../axiosBaseQuery";

// Define a service using a base URL and expected endpoints
export const productApi = createApi({
	reducerPath: "productApi",
	baseQuery: axiosBaseQuery({ baseUrl: "" }),
	endpoints: (builder) => ({
		getProductsByEntityCode: builder.query<GetProductsResponse, { suboccupationId: number, entityCode: string }>({
			query: ({ suboccupationId, entityCode }) => ({
				url: endpoints.GET_PACKAGES_BY_SUBOCCUPATION_ID_AND_ENTITY_CODE,
				method: "POST",
				data: {
                    SuboccupationId: suboccupationId, 
                    ClientEntityCode: entityCode
                },
				headers: { "Content-Type": "application/json", Accept: "application/json, text/plain, */*", },
			}),
            transformResponse: (response) => {
                // console.log('getProductsByEntityCode RESPONSE', response);
                return response;
            }
		}),
	}),
});

// Export hooks for usage in functional components
export const {
	useGetProductsByEntityCodeQuery,
} = productApi;